import { BLUE_500, LILAC_600, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPackCardWidgetStyles = props => {
  var _props$offerBannerTex = props.offerBannerText,
    offerBannerText = _props$offerBannerTex === void 0 ? [] : _props$offerBannerTex,
    _props$cardBorderColo = props.cardBorderColor,
    cardBorderColor = _props$cardBorderColo === void 0 ? LILAC_600 : _props$cardBorderColo,
    carouselData = props.carouselData,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$withRoundedBor = props.withRoundedBorder,
    withRoundedBorder = _props$withRoundedBor === void 0 ? true : _props$withRoundedBor,
    _props$showPackSelect = props.showPackSelection,
    _showPackSelection = _props$showPackSelect === void 0 ? false : _props$showPackSelect,
    _props$packSelectionC = props.packSelectionCardBorderColor,
    packSelectionCardBorderColor = _props$packSelectionC === void 0 ? BLUE_500 : _props$packSelectionC,
    _props$cardBorderWidt = props.cardBorderWidth,
    cardBorderWidth = _props$cardBorderWidt === void 0 ? 1 : _props$cardBorderWidt;
  var spacingToken = tokens.spacing;
  var borderRadiusToken = tokens.borderRadius.BORDER_RADIUS_16;
  var showPackSelection = _showPackSelection && isSelected;
  return StyleSheet.create({
    container: {
      width: '100%',
      borderTopLeftRadius: carouselData ? borderRadiusToken : 0,
      borderTopRightRadius: carouselData ? borderRadiusToken : 0,
      overflow: 'hidden'
    },
    infoTag: {
      marginRight: spacingToken.SPACING_8
    },
    card: Object.assign({
      borderColor: showPackSelection ? packSelectionCardBorderColor : cardBorderColor,
      borderWidth: showPackSelection ? 1.5 : cardBorderWidth
    }, withRoundedBorder && {
      borderTopLeftRadius: carouselData ? 0 : spacingToken.SPACING_16,
      borderTopRightRadius: carouselData ? 0 : borderRadiusToken,
      borderBottomLeftRadius: (offerBannerText === null || offerBannerText === void 0 ? void 0 : offerBannerText.length) ? 0 : borderRadiusToken,
      borderBottomRightRadius: (offerBannerText === null || offerBannerText === void 0 ? void 0 : offerBannerText.length) ? 0 : borderRadiusToken
    }),
    offerBannerContainer: {
      width: '100%',
      borderBottomLeftRadius: borderRadiusToken,
      borderBottomRightRadius: borderRadiusToken,
      paddingVertical: spacingToken.SPACING_8,
      paddingHorizontal: spacingToken.SPACING_12,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    offerBannerTextStyle: {
      marginLeft: spacingToken.SPACING_8
    },
    primaryButtonContainer: {
      paddingBottom: spacingToken.SPACING_16,
      paddingHorizontal: spacingToken.SPACING_13
    },
    offerBannerTextContainer: {
      flexDirection: 'column',
      flex: 1
    },
    titleContainer: {
      marginBottom: spacingToken.SPACING_12
    },
    headingContainer: {
      paddingBottom: spacingToken.SPACING_6
    },
    infoTagContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      paddingBottom: spacingToken.SPACING_12
    }
  });
};